import { defineComponent as _defineComponent } from 'vue';
import DatasetAsImage from "@/components/Dataset/DatasetAsImage/DatasetAsImage.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryDatasetAsImage',
    props: {
        args: null
    },
    setup(__props) {
        const props = __props;
        return { __sfc: true, props, DatasetAsImage };
    }
});
